import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootHeader: {
				display: "flex",
				height: 50,
				alignItems: "center",
				justifyContent: "center"
			},
			titleHeader: {
				fontWeight: 600,
				fontSize: 18
			},
			btnClose: {
				position: "absolute",
				right: 0
			},
			root: {
				background: theme.palette.common.white
			},
			title: {
				color: theme.palette.primary.contrastText,
				fontSize: 20,
				fontWeight: 500,
				marginTop: 40
			}
		}),
	{
		name: "NotificationPage",
		index: 1
	}
);

export default useStyles;
